<template>
  <v-card flat rounded="lg" class="gap-backtest-card">
    <v-card-title class="px-5 py-4">
      <span class="text-h6 font-weight-medium">{{ title }}</span>
    </v-card-title>
    <v-card-text class="px-5 pb-5">
      <v-table density="compact" class="custom-data-table">
        <thead>
          <tr><th>Stock</th><th>Trades</th><th>Win rate</th><th>Wilson LB</th><th>P&amp;L</th><th></th></tr>
        </thead>
        <tbody>
          <tr v-for="row in byStock" :key="row.code">
            <td>{{ row.code }}</td>
            <td>{{ row.tradeCount }}</td>
            <td>{{ formatPct(row.winRatePct) }}</td>
            <td>{{ formatPct(row.wilsonLowerBoundPct) }}</td>
            <td :class="row.pnlRs >= 0 ? 'text-success' : 'text-error'">{{ formatMoney(row.pnlRs) }}</td>
            <td><v-chip size="x-small" variant="tonal" :color="confidenceColor(row.confidenceTier)">{{ confidenceLabel(row.confidenceTier) }}</v-chip></td>
          </tr>
        </tbody>
      </v-table>
      <div v-if="!byStock.length" class="text-caption text-medium-emphasis py-2">No trades in this range yet.</div>
    </v-card-text>
  </v-card>
</template>

<script>
// Shared per-stock P&L ranking -- sorted by raw win rate (bucketByStock()'s
// own convention, app/helpers/trade-analytics.js), with the Wilson lower
// bound shown right next to it so a thin-sample leader's shrinkage toward
// uncertainty is visible at a glance. Used by Day Review's Analytics tab
// (real closed PaperTrade rows) and History tab (backtest-derived rows, via
// buildDashboardStats()'s `byStock` field in day-review.controllers.js) so
// both read the same ranking off the same bucketByStock() shape instead of
// two copies.
export default {
  name: 'StockRankingTable',
  props: {
    byStock: { type: Array, default: () => [] },
    title: { type: String, default: 'Stock ranking' },
  },
  methods: {
    isFiniteNumber(value) {
      return value !== null && value !== undefined && Number.isFinite(Number(value));
    },
    formatPct(value) {
      return this.isFiniteNumber(value) ? `${Number(value).toFixed(1)}%` : '—';
    },
    formatMoney(value) {
      return this.isFiniteNumber(value) ? this.$helper.formatPrice(Number(value)) : '—';
    },
    confidenceColor(tier) {
      if (tier === 'reliable') return 'success';
      if (tier === 'limited') return 'warning';
      return 'error';
    },
    confidenceLabel(tier) {
      if (tier === 'reliable') return 'Reliable';
      if (tier === 'limited') return 'Limited data';
      return 'Experimental';
    },
  },
};
</script>
